export const Hamburger = ({size = 50}) => {
  return (
    <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" width={`${size}px`} height={`${size}px`}><path fill="none" stroke="#000000" strokeMiterlimit="10" strokeWidth="2" d="M50 25L0 25M50 10L0 10M0 40L50 40"/></svg>
  )
}